export default __webpack_public_path__ + "static/media/section-heading-fener.ba1e5e07.svg";